import { put, select, takeLatest } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddMedicationAdministeredData } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'

export function* setRoute() {
  const addMedicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { route, routePNNV, medicationAdministered, addMedicationAdministeredData } = addMedicationAdministeredState
  const selectedMedication = addMedicationAdministeredData.filter(
    (medication) => medication.key === medicationAdministered?.key
  )
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].route = route
    selectedMedication[0].routePNNV = !route ? routePNNV : null
    yield put(setAddMedicationAdministeredData(addMedicationAdministeredData))
  }
}
export function* setRouteSaga() {
  yield takeLatest(
    [AddMedicationAdministeredConstants.SET_ROUTE, AddMedicationAdministeredConstants.SET_ROUTE_PNNV],
    setRoute
  )
}
